import router from 'next/router'
import posthog from 'posthog-js'
import { ReservationOptionsProps } from './type'
import { useTranslation } from 'next-i18next'

export default function ReservationOptions({
  reservationCode,
  setLoading,
  setIsActive
}: ReservationOptionsProps) {
  const { t } = useTranslation(['login'])
  const handlerRedirectUrl = (trackName: string) => {
    posthog.capture(trackName)
    setLoading(true)
    setIsActive(false)
    router.push(`/detalhes/?reserva=${reservationCode}&check=true`)
  }

  return (
    <div className="flex flex-col items-center">
      <h4 className="text-center text-lg text-[21px]">
        {t('no-account-title')}
      </h4>

      <div className="flex gap-3">
        <div className="text-center mt-2">
          <button
            onClick={() => handlerRedirectUrl('reservation_option_view_click')}
            className="mt-4 button--dark w-full"
          >
            {t('button.no-account-view')}
          </button>
        </div>
        <div className="text-center mt-2">
          <button
            onClick={() =>
              handlerRedirectUrl('reservation_option_send_documents_click')
            }
            className="mt-4 button--dark w-full"
          >
            {t('button.no-account-send-documents')}
          </button>
        </div>
      </div>
    </div>
  )
}
